import { Box } from '@mui/material';

import { MaterialSymbol } from '@/components/MaterialSymbol';

/**
 * A card's icon in the shape Web's Storybook `UI/EntityCard` draws it — a
 * 20px glyph on a circle, 8px round it (36px) — in Web's `Icon` primary
 * pairing (`color="primary" backgroundColor="primary"`): navy-100 on navy-10,
 * the light blue (Mette, 3 Nov). Shared by the card and its modal so the
 * header reads the same in both.
 */
export const CardIcon = ({ name }: { name: string }) => (
  <Box
    component="span"
    aria-hidden
    sx={{
      display: 'inline-flex',
      flex: 'none',
      p: 1,
      borderRadius: '50%',
      bgcolor: 'var(--color-navy-10)',
    }}
  >
    <MaterialSymbol name={name} size={20} color="var(--color-navy-100)" />
  </Box>
);
